import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onLinkClick", "name", "value", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from '@hub/checkbox';
import { Link } from '@hub/link';
import React from 'react';
import { useLocation } from '@scentregroup/shared/next/compat/location';
import { useRouter } from '@scentregroup/shared/next/router';
import { jsx as _jsx } from "react/jsx-runtime";
const createLinkFromCheckboxValue = (pathname, search, name, value) => {
  const usp = new URLSearchParams(search);
  let values = usp.getAll(name);
  if (values.includes(value)) {
    values = values.filter(x => x !== value);
  } else {
    values.push(value);
  }
  usp.delete(name);
  values.sort().forEach(val => usp.append(name, val));
  return "".concat(pathname, "?").concat(usp.toString());
};
export const CheckboxWithLink = _ref => {
  let {
      onLinkClick,
      name,
      value,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    basePath
  } = useRouter();
  const {
    pathname,
    search
  } = useLocation();
  const href = React.useMemo(() => createLinkFromCheckboxValue("".concat(basePath).concat(pathname), search, name, value), [basePath, pathname, search, name, value]);
  return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
    value: value
  }, props), {}, {
    "data-id": "searchable-faceted-filter_checkbox-with-link_CheckboxWithLink_Checkbox",
    children: /*#__PURE__*/_jsx(Link, {
      href: href,
      hasUnderline: false,
      onClick: onLinkClick,
      "data-id": "searchable-faceted-filter_checkbox-with-link_CheckboxWithLink_Checkbox_Link",
      children: children
    })
  }));
};